module.exports = {
  "siteMetadata": {
    "title": "Whetstone Field Primary",
    "description": "Our school is situated in Beaufort Way, Aldridge. We are a one form entry primary school with a reputation for providing an excellent education for children between three and eleven years of age.",
    "author": "@accrosoft",
    "siteUrl": "https://www.whetstonefield.co.uk/",
    "defaultSiteImage": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/3K5yTfPmRhSkMMp9CoRl_logo_1.png",
    "siteLogo": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/3K5yTfPmRhSkMMp9CoRl_logo_1.png",
    "siteAvatar": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/3K5yTfPmRhSkMMp9CoRl_logo_1.png",
    "theme_color": null,
    "lang": "en"
  },
  "plugins": [{
    "resolve": "gatsby-plugin-accropress",
    "options": {
      "integrator": {
        "id": "6243d31e-1794-40a6-939a-a168a09f54e2",
        "accessToken": "edfa95e6-6d0f-48aa-9b06-d2cc92e5bbab",
        "redirectURL": "https://www.whetstonefield.co.uk/"
      },
      "siteIDId": "58061cdb-eb47-4b3d-a104-64c68118003b",
      "site": {
        "id": "58061cdb-eb47-4b3d-a104-64c68118003b",
        "title": "Whetstone Field Primary",
        "description": "Our school is situated in Beaufort Way, Aldridge. We are a one form entry primary school with a reputation for providing an excellent education for children between three and eleven years of age.",
        "careersPageURL": null,
        "careersPageVacancyURL": null,
        "siteUrl": "https://www.whetstonefield.co.uk/",
        "siteOwnerId": "89f85076-ce9e-4515-8880-f4d8b9988bf6",
        "siteTypeId": null,
        "deploymentsId": "99c6dd2d-62b3-4ca0-8974-83bb5b11d98f",
        "smartfeedSettingsId": null,
        "weducSettingsId": "ec4818eb-7df5-40f0-8cc0-7fd6fe0b5d74",
        "useCustomContactForm": false,
        "isNovaSite": false,
        "novaSiteID": null,
        "novaCompanyIDs": [],
        "novaGroupIDs": [],
        "smartFeedID": null,
        "tenantUrl": "whetstone-field-primary",
        "author": "@accrosoft",
        "defaultSiteImage": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/3K5yTfPmRhSkMMp9CoRl_logo_1.png",
        "siteLogo": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/3K5yTfPmRhSkMMp9CoRl_logo_1.png",
        "siteAvatar": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/3K5yTfPmRhSkMMp9CoRl_logo_1.png",
        "theme_color": null,
        "lang": "en",
        "tagManagerID": null,
        "googleAnalyticsID": null,
        "googleMapKey": null,
        "useGoogleJavascriptMaps": false,
        "useGoogleGeocodingMaps": false,
        "useGoogleEmbedMaps": false,
        "email_url": null,
        "twitter_url": null,
        "facebook_url": null,
        "nova_page_slug": null,
        "nova_page_id": null,
        "company_thumbnail": null,
        "company_hero": null,
        "company_video": null,
        "company_primary_colour": null,
        "company_primary_colour_hover": null,
        "company_secondary_colour": null,
        "company_secondary_colour_hover": null
      },
      "siteSettings": {
        "id": "c09f0b32-52d9-4784-9df7-7b7b9c91e46b",
        "themeSettingsPayload": [{
          "children": [{
            "id": "logo-image",
            "name": "Logo Image",
            "type": "image",
            "value": "https://cdn2.accropress.com/content-uploads/58061cdb-eb47-4b3d-a104-64c68118003b/58061cdb-eb47-4b3d-a104-64c68118003b/3vtdYFpvS2CkJPcqRNeX_logo_1.png",
            "width": "100",
            "columns": "",
            "default": "https://demo-7.weduc.website/logo.png",
            "groupID": "basic-settings"
          }, {
            "id": "school-name-title",
            "name": "School Name Title",
            "type": "input",
            "value": "Whetstone Field Primary School",
            "width": "100",
            "columns": "",
            "default": "Weduc Academy",
            "groupID": "basic-settings"
          }, {
            "id": "school-name-subtitle",
            "name": "School Name Subtitle",
            "type": "input",
            "value": " ",
            "width": "100",
            "columns": "",
            "default": "Demo School",
            "groupID": "basic-settings"
          }, {
            "id": "theme-font-settings",
            "name": "Theme font settings",
            "type": "dropdown",
            "width": "100",
            "columns": "",
            "default": [{
              "name": "Poppins",
              "value": "Poppins",
              "fontFamily": "Poppins"
            }],
            "hiddenField": true
          }, {
            "id": "theme-colour-settings",
            "name": "Theme Colour Settings",
            "type": "group",
            "width": "100",
            "columns": [{
              "id": "theme-colour-settings-primary",
              "name": "Primary Colour",
              "type": "colour",
              "default": "#1fbdb7",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "theme-colour-settings-secondary",
              "name": "Secondary Colour",
              "type": "colour",
              "default": "#2d3e50",
              "maximum": 0,
              "minimum": 0
            }],
            "default": "",
            "groupID": "colour-settings",
            "children": [[{
              "id": "theme-colour-settings-primary",
              "name": "Primary Colour",
              "type": "colour",
              "color": "#ea2e2e",
              "default": "#1fbdb7",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "theme-colour-settings-secondary",
              "name": "Secondary Colour",
              "type": "colour",
              "color": "#ea2e2e",
              "default": "#2d3e50",
              "maximum": 0,
              "minimum": 0
            }]]
          }, {
            "id": "home-banner-settings",
            "name": "Hero Banner Settings",
            "type": "group",
            "width": "100",
            "columns": [{
              "id": "home-banner-settings-image",
              "name": "Default Hero Image",
              "type": "input",
              "default": "https://cdn2.accropress.com/4953d6eb-4231-4cc5-bfeb-f429d19efc1b/c59afd92-2ba0-42f9-bdd2-69453ca150b4.jpeg",
              "maximum": 0,
              "minimum": 0
            }],
            "default": "",
            "groupID": "hero-banner-settings",
            "children": [[{
              "id": "home-banner-settings-image",
              "name": "Default Hero Image",
              "type": "input",
              "value": "hero image",
              "default": "https://cdn2.accropress.com/4953d6eb-4231-4cc5-bfeb-f429d19efc1b/c59afd92-2ba0-42f9-bdd2-69453ca150b4.jpeg",
              "maximum": 0,
              "minimum": 0
            }]]
          }, {
            "id": "weduc-widgets-settings",
            "name": "Weduc Widgets Settings",
            "type": "group",
            "width": "100",
            "columns": [{
              "id": "weduc-widgets-settings-websitesid",
              "name": "Weduc Websites ID",
              "type": "input",
              "default": "weducdemositeuser",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "weduc-widgets-settings-containerid",
              "name": "Weduc Main Container ID",
              "type": "input",
              "default": "281474976810657",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "weduc-widgets-settings-entityid",
              "name": "Weduc Main Entity ID",
              "type": "input",
              "default": "281474976810657",
              "maximum": 0,
              "minimum": 0
            }],
            "default": "",
            "groupID": "weduc-widgets-settings",
            "children": [[{
              "id": "weduc-widgets-settings-websitesid",
              "name": "Weduc Websites ID",
              "type": "input",
              "default": "weducdemositeuser",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "weduc-widgets-settings-containerid",
              "name": "Weduc Main Container ID",
              "type": "input",
              "default": "281474976810657",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "weduc-widgets-settings-entityid",
              "name": "Weduc Main Entity ID",
              "type": "input",
              "default": "281474976810657",
              "maximum": 0,
              "minimum": 0
            }]]
          }]
        }],
        "menusPayload": [],
        "widgetsPayload": [{
          "children": [{
            "id": "footer-contact-details",
            "name": "Contact Details",
            "type": "group",
            "width": "100",
            "columns": [{
              "id": "footer-contact-details-ad1",
              "name": "Address Line One",
              "type": "input",
              "default": "Weduc Academy",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-ad2",
              "name": "Address Line Two",
              "type": "input",
              "default": "21 Jubilee Drive Loughborough",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-ad3",
              "name": "Address Line Three",
              "type": "input",
              "default": "LE11 5XS United Kingdom",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-tel",
              "name": "Telephone Number",
              "type": "input",
              "default": "+ 44 (0)1509 221 349",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-email",
              "name": "Email Address",
              "type": "input",
              "default": " info@weduc.co.uk",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-insta",
              "name": "Instagram Link",
              "type": "input",
              "default": null,
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-facebook",
              "name": "Facebook Link",
              "type": "input",
              "default": null,
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-twitter",
              "name": "Twitter Link",
              "type": "input",
              "default": null,
              "maximum": 0,
              "minimum": 0
            }],
            "default": "",
            "children": [[{
              "id": "footer-contact-details-ad1",
              "name": "Address Line One",
              "type": "input",
              "value": "Whetstone Field Primary School",
              "default": "Weduc Academy",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-ad2",
              "name": "Address Line Two",
              "type": "input",
              "value": "Beaufort Way, Walsall",
              "default": "21 Jubilee Drive Loughborough",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-ad3",
              "name": "Address Line Three",
              "type": "input",
              "value": "West Midlands, WS9 0HJ",
              "default": "LE11 5XS United Kingdom",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-tel",
              "name": "Telephone Number",
              "type": "input",
              "value": "01922 743498",
              "default": "+ 44 (0)1509 221 349",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-email",
              "name": "Email Address",
              "type": "input",
              "value": "office@whetstonefield.co.uk",
              "default": " info@weduc.co.uk",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-insta",
              "name": "Instagram Link",
              "type": "input",
              "default": "",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-facebook",
              "name": "Facebook Link",
              "type": "input",
              "value": "https://en-gb.facebook.com/whetstonefield/",
              "default": "",
              "maximum": 0,
              "minimum": 0
            }, {
              "id": "footer-contact-details-twitter",
              "name": "Twitter Link",
              "type": "input",
              "value": "https://twitter.com/WhetstoneField",
              "default": "",
              "maximum": 0,
              "minimum": 0
            }]]
          }, {
            "id": "footer-useful-links",
            "name": "Useful Links",
            "type": "group",
            "width": "100",
            "columns": [{
              "id": "footer-useful-links-item",
              "name": "Link Item",
              "type": "url",
              "default": "",
              "maximum": 0,
              "minimum": 0
            }],
            "default": "",
            "children": [[{
              "id": "footer-useful-links-item",
              "name": "Link Item",
              "text": "BBC Bitesize",
              "type": "url",
              "value": "https://www.bbc.co.uk/bitesize/dailylessons",
              "newTab": true,
              "default": "",
              "maximum": 0,
              "minimum": 0
            }], [{
              "id": "footer-useful-links-item",
              "name": "Link Item",
              "text": "British Library",
              "type": "url",
              "value": "https://www.bl.uk/childrens-books",
              "newTab": true,
              "default": "",
              "maximum": 0,
              "minimum": 0
            }], [{
              "id": "footer-useful-links-item",
              "name": "Link Item",
              "text": "David Walliams - includes a free audiobook every day!",
              "type": "url",
              "value": "https://www.worldofdavidwalliams.com",
              "newTab": true,
              "default": "",
              "maximum": 0,
              "minimum": 0
            }]],
            "repeater": true
          }, {
            "id": "footer-useful-resources",
            "name": "Useful Resources",
            "type": "group",
            "width": "100",
            "columns": [{
              "id": "footer-useful-resources-item",
              "name": "Link Item",
              "type": "url",
              "default": "",
              "maximum": 0,
              "minimum": 0
            }],
            "default": "",
            "children": [[{
              "id": "footer-useful-resources-item",
              "name": "Link Item",
              "text": "National Geographic for Kids",
              "type": "url",
              "value": "https://www.natgeokids.com/uk/teacher-category/primary-resources/",
              "newTab": true,
              "default": "",
              "maximum": 0,
              "minimum": 0
            }]],
            "repeater": true
          }, {
            "id": "footer-information",
            "name": "Information",
            "type": "group",
            "width": "100",
            "columns": [{
              "id": "footer-information-item",
              "name": "Link Item",
              "type": "url",
              "default": "",
              "maximum": 0,
              "minimum": 0
            }],
            "default": "",
            "children": [[{
              "id": "footer-information-item",
              "name": "Link Item",
              "type": "url",
              "default": "",
              "maximum": 0,
              "minimum": 0
            }]],
            "repeater": true
          }],
          "widgetID": "footer"
        }],
        "theme": {
          "id": "ecef0870-b44e-40b8-acf7-dace08ca6b4a",
          "name": "Alfred Weduc Websites Theme",
          "version": "1.0.0",
          "description": "Designed primarily for use with Primary Schools but can be used across all school types, features direct Weduc integration.",
          "tags": [],
          "previewThumbnail": "https://website-screens.accropress.com/be683bce-273c-4b7d-b1d5-1f2fc9b392e5.png",
          "previewDomain": "https://demo-alfred.weduc.website",
          "themeSettingsDefinition": [{
            "children": [{
              "id": "logo-image",
              "name": "Logo Image",
              "type": "image",
              "width": "100",
              "columns": "",
              "default": "https://demo-7.weduc.website/logo.png",
              "groupID": "basic-settings"
            }, {
              "id": "school-name-title",
              "name": "School Name Title",
              "type": "input",
              "width": "100",
              "columns": "",
              "default": "Weduc Academy",
              "groupID": "basic-settings"
            }, {
              "id": "school-name-subtitle",
              "name": "School Name Subtitle",
              "type": "input",
              "width": "100",
              "columns": "",
              "default": "Demo School",
              "groupID": "basic-settings"
            }, {
              "id": "theme-font-settings",
              "name": "Theme font settings",
              "type": "dropdown",
              "width": "100",
              "columns": "",
              "default": [{
                "name": "Poppins",
                "value": "Poppins",
                "fontFamily": "Poppins"
              }],
              "hiddenField": true
            }, {
              "id": "theme-colour-settings",
              "name": "Theme Colour Settings",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "theme-colour-settings-primary",
                "name": "Primary Colour",
                "type": "colour",
                "default": "#1fbdb7",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "theme-colour-settings-secondary",
                "name": "Secondary Colour",
                "type": "colour",
                "default": "#2d3e50",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "groupID": "colour-settings",
              "children": [[{
                "id": "theme-colour-settings-primary",
                "name": "Primary Colour",
                "type": "colour",
                "default": "#1fbdb7",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "theme-colour-settings-secondary",
                "name": "Secondary Colour",
                "type": "colour",
                "default": "#2d3e50",
                "maximum": 0,
                "minimum": 0
              }]]
            }, {
              "id": "home-banner-settings",
              "name": "Hero Banner Settings",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "home-banner-settings-image",
                "name": "Default Hero Image",
                "type": "input",
                "default": "https://cdn2.accropress.com/4953d6eb-4231-4cc5-bfeb-f429d19efc1b/c59afd92-2ba0-42f9-bdd2-69453ca150b4.jpeg",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "groupID": "hero-banner-settings",
              "children": [[{
                "id": "home-banner-settings-image",
                "name": "Default Hero Image",
                "type": "input",
                "default": "https://cdn2.accropress.com/4953d6eb-4231-4cc5-bfeb-f429d19efc1b/c59afd92-2ba0-42f9-bdd2-69453ca150b4.jpeg",
                "maximum": 0,
                "minimum": 0
              }]]
            }, {
              "id": "weduc-widgets-settings",
              "name": "Weduc Widgets Settings",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "weduc-widgets-settings-websitesid",
                "name": "Weduc Websites ID",
                "type": "input",
                "default": "weducdemositeuser",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "weduc-widgets-settings-containerid",
                "name": "Weduc Main Container ID",
                "type": "input",
                "default": "281474976810657",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "weduc-widgets-settings-entityid",
                "name": "Weduc Main Entity ID",
                "type": "input",
                "default": "281474976810657",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "groupID": "weduc-widgets-settings",
              "children": [[{
                "id": "weduc-widgets-settings-websitesid",
                "name": "Weduc Websites ID",
                "type": "input",
                "default": "weducdemositeuser",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "weduc-widgets-settings-containerid",
                "name": "Weduc Main Container ID",
                "type": "input",
                "default": "281474976810657",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "weduc-widgets-settings-entityid",
                "name": "Weduc Main Entity ID",
                "type": "input",
                "default": "281474976810657",
                "maximum": 0,
                "minimum": 0
              }]]
            }]
          }],
          "menusDefinition": [{
            "id": "primary-menu",
            "name": "Primary Menu",
            "children": [],
            "automatic-menu": true
          }],
          "widgetsDefinition": [{
            "children": [{
              "id": "footer-contact-details",
              "name": "Contact Details",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "footer-contact-details-ad1",
                "name": "Address Line One",
                "type": "input",
                "default": "Weduc Academy",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-ad2",
                "name": "Address Line Two",
                "type": "input",
                "default": "21 Jubilee Drive Loughborough",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-ad3",
                "name": "Address Line Three",
                "type": "input",
                "default": "LE11 5XS United Kingdom",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-tel",
                "name": "Telephone Number",
                "type": "input",
                "default": "+ 44 (0)1509 221 349",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-email",
                "name": "Email Address",
                "type": "input",
                "default": " info@weduc.co.uk",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-insta",
                "name": "Instagram Link",
                "type": "input",
                "default": null,
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-facebook",
                "name": "Facebook Link",
                "type": "input",
                "default": null,
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-twitter",
                "name": "Twitter Link",
                "type": "input",
                "default": null,
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "children": [[{
                "id": "footer-contact-details-ad1",
                "name": "Address Line One",
                "type": "input",
                "default": "Weduc Academy",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-ad2",
                "name": "Address Line Two",
                "type": "input",
                "default": "21 Jubilee Drive Loughborough",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-ad3",
                "name": "Address Line Three",
                "type": "input",
                "default": "LE11 5XS United Kingdom",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-tel",
                "name": "Telephone Number",
                "type": "input",
                "default": "+ 44 (0)1509 221 349",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-email",
                "name": "Email Address",
                "type": "input",
                "default": " info@weduc.co.uk",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-insta",
                "name": "Instagram Link",
                "type": "input",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-facebook",
                "name": "Facebook Link",
                "type": "input",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }, {
                "id": "footer-contact-details-twitter",
                "name": "Twitter Link",
                "type": "input",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }]]
            }, {
              "id": "footer-useful-links",
              "name": "Useful Links",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "footer-useful-links-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "children": [[{
                "id": "footer-useful-links-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }]],
              "repeater": true
            }, {
              "id": "footer-useful-resources",
              "name": "Useful Resources",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "footer-useful-resources-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "children": [[{
                "id": "footer-useful-resources-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }]],
              "repeater": true
            }, {
              "id": "footer-information",
              "name": "Information",
              "type": "group",
              "width": "100",
              "columns": [{
                "id": "footer-information-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }],
              "default": "",
              "children": [[{
                "id": "footer-information-item",
                "name": "Link Item",
                "type": "url",
                "default": "",
                "maximum": 0,
                "minimum": 0
              }]],
              "repeater": true
            }],
            "widgetID": "footer"
          }],
          "templates": []
        }
      }
    }
  }, "gatsby-plugin-react-helmet", {
    "resolve": "gatsby-plugin-s3",
    "options": {
      "bucketName": "null-bucket.accropress.com",
      "mergeCachingParams": true,
      "generateRoutingRules": true,
      "generateRedirectObjectsForPermanentRedirects": false,
      "generateIndexPageForRedirect": true,
      "generateMatchPathRewrites": true,
      "removeNonexistentObjects": true,
      "enableS3StaticWebsiteHosting": false
    }
  }, "gatsby-plugin-sass", {
    "resolve": "gatsby-source-filesystem",
    "options": {
      "name": "images",
      "path": "./src/images"
    }
  }, {
    "resolve": "gatsby-plugin-react-leaflet",
    "options": {
      "linkStyles": true
    }
  }, "gatsby-transformer-sharp", "gatsby-plugin-sharp", {
    "resolve": "gatsby-plugin-sitemap",
    "options": {
      "output": "/sitemap-pages.xml"
    }
  }, {
    "resolve": "gatsby-plugin-seo",
    "options": {
      "siteName": "Whetstone Field Primary",
      "defaultSiteImage": "https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/3K5yTfPmRhSkMMp9CoRl_logo_1.png",
      "siteUrl": "https://www.whetstonefield.co.uk/",
      "globalSchema": "{\n                  \"@type\": \"WebSite\",\n                  \"url\": https://www.whetstonefield.co.uk/,\n                  \"name\": Whetstone Field Primary,\n                  \"image\": {\n                    \"@type\": \"ImageObject\",\n                    \"url\": https://cdn2.accropress.com/content-uploads/5cac3247-b599-459f-8c1c-47ab12db7578/global/3K5yTfPmRhSkMMp9CoRl_logo_1.png,\n                    \"caption\": Whetstone Field Primary\n                  }\n                }"
    }
  }, {
    "resolve": "gatsby-plugin-manifest",
    "options": {
      "name": "Whetstone Field Primary",
      "short_name": "Whetstone Field Primary",
      "start_url": "/",
      "background_color": "#fff",
      "theme_color": "#000",
      "display": "standalone",
      "icon": "static/img/apple-icon.png"
    }
  }, {
    "resolve": "@accrosoft-ltd/gatsby-plugin-use-dark-mode",
    "options": {
      "classNameDark": "dark-mode",
      "classNameLight": "light-mode",
      "storageKey": "darkMode",
      "minify": true,
      "usePrefersColorScheme": false
    }
  }]
};